// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { AccountTemplate } from './account-template';
import { Admin } from './admin';
import { Dividend } from './dividend';
import { Shareholding } from './shareholding';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class ShareholderClass extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  shareholderClassId!: number;
  accountId?: number;
  adminId!: number;
  authorised!: number;
  createdBy!: string;
  createdDate!: Date;
  description!: string;
  issued!: number;
  paidUp!: number;
  paidUpNotCash!: number;
  parValue!: number;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  account!: Account;
  accountTemplates!: AccountTemplate[];
  accounts!: Account[];
  admin!: Admin;
  dividends!: Dividend[];
  shareholdings!: Shareholding[];
}

